// extracted by mini-css-extract-plugin
export default {"itemsWrapper":"CasinoBurgerMenu_itemsWrapper--PDX","listItemClass":"CasinoBurgerMenu_listItemClass--oAr"};